export default {
  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0, // initial value. watcher will update it when we fetch the data
      },
      rowsPerPageItems: [25, 50, 100, 300, 'All'],
    };
  },
  computed: {
    paginationParams() {
      const { rowsPerPage, page } = this.pagination;

      return {
        page,
        take: rowsPerPage,
        skip: rowsPerPage * (page - 1),
        pageSize: rowsPerPage,
      };
    },
  },
  methods: {
    loadNextPage(nextPageMeta) {
      const { page, rowsPerPage, totalItems } = nextPageMeta;

      if (page !== this.pagination.page || rowsPerPage !== this.pagination.rowsPerPage) {
        if (rowsPerPage === 'All') {
          nextPageMeta.rowsPerPage = totalItems; // eslint-disable-line no-param-reassign
        }

        window.scrollTo(0, 0);
        this.pagination = nextPageMeta;
        this.fetchData(this.paginationParams);
      }
    },
    sortItems(items) {
      const { sortBy, descending } = this.pagination;
      let itemsCopy = items;

      itemsCopy = itemsCopy.sort((a, b) => {
        const sortA = a[sortBy];
        const sortB = b[sortBy];

        if (descending) {
          if (sortA < sortB) return 1;
          if (sortA > sortB) return -1;

          return 0;
        }
        if (sortA < sortB) return -1;
        if (sortA > sortB) return 1;

        return 0;
      });

      return itemsCopy;
    },
    changeSort(column, items) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }

      this.sortItems(items);
    },
  },
  watch: {
    meta() {
      this.pagination.totalItems = this.meta.total;
    },
  },
};
